var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { MPInstancesHub } from "@/api/RequestAxios/RequestAxiosHub";
import { packQueryParams } from "../utils";
import { toJS } from "mobx";
import { unpackWabas } from "./waba.mapper";
import { UIModelIntegrations, } from "../channels/channels.model";
import qs from "qs";
var wabaUrl = function () { return "/partners/waba_setup"; };
var wabaTriggerRegistrationUrl = function (appId) {
    return "/partners/waba_trigger_registration/".concat(appId);
};
var wabaFinishRegistrationUrl = function (appId) {
    return "/partners/waba_finish_registration/".concat(appId);
};
export var getWabas = function (queryParams) { return __awaiter(void 0, void 0, Promise, function () {
    var data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.get(wabaUrl(), {
                    params: queryParams && packQueryParams(queryParams),
                    paramsSerializer: function (params) {
                        var filters = params.filters, otherParams = __rest(params, ["filters"]);
                        var serializedQueryString = qs.stringify(otherParams, {
                            arrayFormat: "repeat",
                        });
                        return "".concat(serializedQueryString, "&filters=").concat(JSON.stringify(toJS(filters)));
                    },
                })];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, new UIModelIntegrations(unpackWabas(data))];
        }
    });
}); };
export var setupWaba = function (payload) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post(wabaUrl(), payload)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
export var wabaTriggerRegistration = function (waba, params) { return __awaiter(void 0, void 0, void 0, function () {
    var data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post(wabaTriggerRegistrationUrl(waba.appId), __assign(__assign({}, (params.verification_method
                    ? { verification_method: params.verification_method }
                    : {})), (params.certificate ? { certificate: params.certificate } : {})))];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, data];
        }
    });
}); };
export var wabaTriggerRegistrationWithAppId = function (appId, params) { return __awaiter(void 0, void 0, void 0, function () {
    var data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post(wabaTriggerRegistrationUrl(appId), __assign(__assign(__assign({}, (params.verification_method
                    ? { verification_method: params.verification_method }
                    : {})), (params.certificate ? { certificate: params.certificate } : {})), (params.setup_flow ? { setup_flow: params.setup_flow } : {})))];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, data];
        }
    });
}); };
export var wabaFinishRegistration = function (waba, params) { return __awaiter(void 0, void 0, void 0, function () {
    var data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post(wabaFinishRegistrationUrl(waba.appId), params)];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, data];
        }
    });
}); };
//# sourceMappingURL=data:application/json;base64,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